// extracted by mini-css-extract-plugin
export default {"results":"results-module--results--21auf"};